import { reaction } from 'mobx';
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useFilterQueryParams(store) {
	const initializedRef = useRef(false);
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		if (initializedRef.current) return;

		initializedRef.current = true;

		store.applyQueryParams(searchParams);

		const params = store.toQueryParams();

		if (Object.keys(params).length) setSearchParams(params, { replace: true });
	}, [store, searchParams, setSearchParams]);

	useEffect(() => {
		const dispose = reaction(
			() => store.toQueryParams(),
			(params) => setSearchParams(params, { replace: true }),
			{ fireImmediately: false }
		);

		return () => dispose();
	}, [store, setSearchParams]);
}
